import PropTypes from "prop-types"
import { Flex } from "antd"
import ReservationCard from "./ReservationCard"

// Mobile (xs–sm) view for Reservations: a card per row, tapping opens the detail.
const ReservationMobileList = ({ items = [], onView }) => (
  <Flex vertical gap={10}>
    {items.map((item) => (
      <ReservationCard key={item.id} item={item} onView={onView} />
    ))}
  </Flex>
)

ReservationMobileList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onView: PropTypes.func
}

export default ReservationMobileList
